import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=45571868&scoped=true&"
import script from "./Foot.vue?vue&type=script&lang=js&"
export * from "./Foot.vue?vue&type=script&lang=js&"
import style0 from "./Foot.vue?vue&type=style&index=0&id=45571868&scoped=true&lang=css&"
import style1 from "./Foot.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45571868",
  null
  
)

export default component.exports